import { Fragment } from 'react';

interface YAxisGridProps<Tick> {
  yScale: (tick: Tick) => number;
  ticks: Tick[];
  x: {
    start: number;
    end: number;
  };
  labelOffset: {
    x: number;
    y: number;
  };
  side?: 'left' | 'right';
  labelFormat?: (tick: Tick) => string;
  getTickProps?: (tick: Tick) =>
    | {
        stroke?: string;
        strokeWidth?: number;
      }
    | undefined;
  getLabelProps?: (tick: Tick) =>
    | {
        fill?: string;
        fontSize?: string;
        fontWeight?: string;
      }
    | undefined;
}

const YAxisGrid = <Tick extends number>({
  yScale,
  ticks,
  x,
  labelOffset,
  side = 'left',
  labelFormat,
  getTickProps,
  getLabelProps,
}: YAxisGridProps<Tick>) => {
  const isRight = side === 'right';

  return (
    <g>
      {ticks.map((tick, idx) => {
        const y = yScale(tick);
        const { stroke = '#D9D9D9', strokeWidth = 1 } = getTickProps?.(tick) ?? {};
        const { fill = '#000', fontSize = '14px', fontWeight = '300' } = getLabelProps?.(tick) ?? {};

        const labelX = isRight ? x.start + labelOffset.x : x.start - labelOffset.x;

        return (
          <Fragment key={`tick-${idx}-${tick}`}>
            <line x1={x.start} y1={y} x2={x.end} y2={y} stroke={stroke} strokeWidth={strokeWidth} />
            <text
              x={labelX}
              y={y + labelOffset.y}
              textAnchor={isRight ? 'start' : 'end'}
              fill={fill}
              fontSize={fontSize}
              fontWeight={fontWeight}
            >
              {labelFormat ? labelFormat(tick) : tick}
            </text>
          </Fragment>
        );
      })}
    </g>
  );
};

export { YAxisGrid };
